import { DashboardGraphicalConfig } from '../../dashboard/dashboard-graphical';
import { DashboardMetricSet } from '../../dashboard/dashboard-metric';
import {
    RiskDashboardRequest,
    RISK_METRIC_CATEGORIES,
    convertFromConstantToHuman,
    RiskMetricDataUsageType
} from '@liquitics/transaction';

import {
    getSingleDayAnalysisForGraphical,
    getCompareAnalysisForGraphical,
    getHistoricalTrendForGraphical,
    getStressComparisonAnalysis,
    RiskGraphicalOutput,
} from './risk-graphical-functions';

// tslint:disable:max-line-length
export const RISK_GRAPHICAL_CONFIGS: DashboardGraphicalConfig[] = [
    new DashboardGraphicalConfig('IB01', RISK_METRIC_CATEGORIES.IntradayBalance, 'Balance', 'TimeLine', 'Single Day'),
    new DashboardGraphicalConfig('IB02', RISK_METRIC_CATEGORIES.IntradayBalance, 'Balance', 'CompareTimeLine', 'Compare Days'),
    new DashboardGraphicalConfig('IB03', RISK_METRIC_CATEGORIES.IntradayBalance, 'Balance', 'TrendLine', 'Compare Stresses'),
    new DashboardGraphicalConfig('GP01', RISK_METRIC_CATEGORIES.GrossPayments, 'By Client Group', 'DefaultPie', 'Single Day'),
    new DashboardGraphicalConfig('GP02', RISK_METRIC_CATEGORIES.GrossPayments, 'Incoming by Client Group', 'DefaultPie', 'Single Day'),
    new DashboardGraphicalConfig('GP03', RISK_METRIC_CATEGORIES.GrossPayments, 'Outgoing by Client Group', 'DefaultPie', 'Single Day'),
    new DashboardGraphicalConfig('GP04', RISK_METRIC_CATEGORIES.GrossPayments, 'By Product Type', 'DefaultPie', 'Single Day'),
    new DashboardGraphicalConfig('GP05', RISK_METRIC_CATEGORIES.GrossPayments, 'Incoming by Product Type', 'DefaultPie', 'Single Day'),
    new DashboardGraphicalConfig('GP06', RISK_METRIC_CATEGORIES.GrossPayments, 'Outgoing by Product Type', 'DefaultPie', 'Single Day'),
    new DashboardGraphicalConfig('GP07', RISK_METRIC_CATEGORIES.GrossPayments, 'By Amount', 'DefaultLine', 'Historical Trend'),
    new DashboardGraphicalConfig('GP08', RISK_METRIC_CATEGORIES.GrossPayments, 'By Count', 'DefaultLine', 'Historical Trend'),
    new DashboardGraphicalConfig('TSP01', RISK_METRIC_CATEGORIES.TimeSpecificPayments, 'Time Based Payments Summary', 'DefaultScatterPlot', 'Single Day'),
    new DashboardGraphicalConfig('TSP02', RISK_METRIC_CATEGORIES.TimeSpecificPayments, 'Time Specific Payments over Time', 'CompareTimeColumn', 'Single Day'),
    new DashboardGraphicalConfig('TSP03', RISK_METRIC_CATEGORIES.TimeSpecificPayments, 'Delayed Payments', 'DefaultColumn', 'Single Day'),
    new DashboardGraphicalConfig('PTP01', RISK_METRIC_CATEGORIES.PassThroughPayments, 'By Account', 'DefaultStackedColumn', 'Single Day'),
    new DashboardGraphicalConfig('PTP02', RISK_METRIC_CATEGORIES.PassThroughPayments, 'By Time', 'TimeStackedColumn', 'Single Day'),
    new DashboardGraphicalConfig('PTP03', RISK_METRIC_CATEGORIES.PassThroughPayments, 'By Amount', 'DefaultLine', 'Historical Trend'),
    new DashboardGraphicalConfig('PTP04', RISK_METRIC_CATEGORIES.PassThroughPayments, 'By Number of Payments', 'DefaultLine', 'Historical Trend'),
    new DashboardGraphicalConfig('CL01', RISK_METRIC_CATEGORIES.CreditLines, 'Usage Summary', 'TimeLine', 'Single Day'),
    new DashboardGraphicalConfig('CL02', RISK_METRIC_CATEGORIES.CreditLines, 'Usage', 'DefaultColumn', 'Compare Days'),
    new DashboardGraphicalConfig('CL03', RISK_METRIC_CATEGORIES.CreditLines, 'Usage', 'DefaultLine', 'Historical Trend'),
    new DashboardGraphicalConfig('TP01', RISK_METRIC_CATEGORIES.Throughput, 'Amount By Client Group', 'CompareTimeLine', 'Single Day', ['Pay', 'Rec']),
    new DashboardGraphicalConfig('TP02', RISK_METRIC_CATEGORIES.Throughput, 'Count By Client Group', 'CompareTimeLine', 'Single Day', ['Pay', 'Rec']),
    new DashboardGraphicalConfig('TP03', RISK_METRIC_CATEGORIES.Throughput, 'Amount By Product', 'CompareTimeLine', 'Single Day', ['Pay', 'Rec']),
    new DashboardGraphicalConfig('TP04', RISK_METRIC_CATEGORIES.Throughput, 'Count By Product', 'CompareTimeLine', 'Single Day', ['Pay', 'Rec']),
    new DashboardGraphicalConfig('TP05', RISK_METRIC_CATEGORIES.Throughput, 'Amount By Settlement Channel', 'CompareTimeLine', 'Single Day', ['Pay', 'Rec']),
    new DashboardGraphicalConfig('TP06', RISK_METRIC_CATEGORIES.Throughput, 'Count By Settlement Channel', 'CompareTimeLine', 'Single Day', ['Pay', 'Rec']),
    new DashboardGraphicalConfig('TP07', RISK_METRIC_CATEGORIES.Throughput, 'Amount By Account', 'CompareTimeLine', 'Single Day', ['Pay', 'Rec']),
    new DashboardGraphicalConfig('TP08', RISK_METRIC_CATEGORIES.Throughput, 'Count By Account', 'CompareTimeLine', 'Single Day', ['Pay', 'Rec']),
    new DashboardGraphicalConfig('OTP01', RISK_METRIC_CATEGORIES.Throughput, 'Outflow Amount by Client Group', 'CompareTimeLine', 'Compare Days', ['Pay0', 'Pay1']),
    new DashboardGraphicalConfig('OTP02', RISK_METRIC_CATEGORIES.Throughput, 'Outflow Count by Client Group', 'CompareTimeLine', 'Compare Days', ['Pay0', 'Pay1']),
    new DashboardGraphicalConfig('OTP03', RISK_METRIC_CATEGORIES.Throughput, 'Outflow Amount by Product', 'CompareTimeLine', 'Compare Days', ['Pay0', 'Pay1']),
    new DashboardGraphicalConfig('OTP04', RISK_METRIC_CATEGORIES.Throughput, 'Outflow Count Throughput Comparison by Product', 'CompareTimeLine', 'Compare Days', ['Pay0', 'Pay1']),
    new DashboardGraphicalConfig('OTP05', RISK_METRIC_CATEGORIES.Throughput, 'Outflow Amount by Settlement Channel', 'CompareTimeLine', 'Compare Days', ['Pay0', 'Pay1']),
    new DashboardGraphicalConfig('OTP06', RISK_METRIC_CATEGORIES.Throughput, 'Outflow Count by Settlement Channel', 'CompareTimeLine', 'Compare Days', ['Pay0', 'Pay1']),
    new DashboardGraphicalConfig('OTP07', RISK_METRIC_CATEGORIES.Throughput, 'Outflow Amount by Account', 'CompareTimeLine', 'Compare Days', ['Pay0', 'Pay1']),
    new DashboardGraphicalConfig('OTP08', RISK_METRIC_CATEGORIES.Throughput, 'Outflow Count by Account', 'CompareTimeLine', 'Compare Days', ['Pay0', 'Pay1']),
    new DashboardGraphicalConfig('OTP09', RISK_METRIC_CATEGORIES.Throughput, 'Outgoing', 'TrendLine', 'Historical Trend'),
    new DashboardGraphicalConfig('OTP10', RISK_METRIC_CATEGORIES.Throughput, 'Outgoing', 'TrendLine', 'Compare Stresses'),
    new DashboardGraphicalConfig('ITP01', RISK_METRIC_CATEGORIES.Throughput, 'Inflow Amount by Client Group', 'CompareTimeLine', 'Compare Days', ['Rec0', 'Rec1']),
    new DashboardGraphicalConfig('ITP02', RISK_METRIC_CATEGORIES.Throughput, 'Inflow Count by Client Group', 'CompareTimeLine', 'Compare Days', ['Rec0', 'Rec1']),
    new DashboardGraphicalConfig('ITP03', RISK_METRIC_CATEGORIES.Throughput, 'Inflow Amount by Product', 'CompareTimeLine', 'Compare Days', ['Rec0', 'Rec1']),
    new DashboardGraphicalConfig('ITP04', RISK_METRIC_CATEGORIES.Throughput, 'Inflow Count by Product', 'CompareTimeLine', 'Compare Days', ['Rec0', 'Rec1']),
    new DashboardGraphicalConfig('ITP05', RISK_METRIC_CATEGORIES.Throughput, 'Inflow Amount by Settlement Channel', 'CompareTimeLine', 'Compare Days', ['Rec0', 'Rec1']),
    new DashboardGraphicalConfig('ITP06', RISK_METRIC_CATEGORIES.Throughput, 'Inflow Count by Settlement Channel', 'CompareTimeLine', 'Compare Days', ['Rec0', 'Rec1']),
    new DashboardGraphicalConfig('ITP07', RISK_METRIC_CATEGORIES.Throughput, 'Inflow Amount by Account', 'CompareTimeLine', 'Compare Days', ['Rec0', 'Rec1']),
    new DashboardGraphicalConfig('ITP08', RISK_METRIC_CATEGORIES.Throughput, 'Inflow Count by Account', 'CompareTimeLine', 'Compare Days', ['Rec0', 'Rec1']),
    new DashboardGraphicalConfig('ITP09', RISK_METRIC_CATEGORIES.Throughput, 'Incoming', 'TrendLine', 'Historical Trend'),
    new DashboardGraphicalConfig('ITP10', RISK_METRIC_CATEGORIES.Throughput, 'Incoming', 'TrendLine', 'Compare Stresses'),
    new DashboardGraphicalConfig('SDA01', RISK_METRIC_CATEGORIES.StartOfDayAvenues, 'By Type', 'DefaultPie', 'Single Day'),
    new DashboardGraphicalConfig('SDA02', RISK_METRIC_CATEGORIES.StartOfDayAvenues, 'By Maturity', 'DefaultPie', 'Single Day'),
    new DashboardGraphicalConfig('SDA03', RISK_METRIC_CATEGORIES.StartOfDayAvenues, 'By Level', 'DefaultPie', 'Single Day'),
    new DashboardGraphicalConfig('SDA04', RISK_METRIC_CATEGORIES.StartOfDayAvenues, 'By GC/SC', 'DefaultPie', 'Single Day'),
    new DashboardGraphicalConfig('SDA05', RISK_METRIC_CATEGORIES.StartOfDayAvenues, 'By Rating', 'DefaultPie', 'Single Day'),
    new DashboardGraphicalConfig('SDA06', RISK_METRIC_CATEGORIES.StartOfDayAvenues, 'By Country', 'DefaultPie', 'Single Day'),
    new DashboardGraphicalConfig('SDA07', RISK_METRIC_CATEGORIES.StartOfDayAvenues, 'By Sector', 'DefaultPie', 'Single Day'),
    new DashboardGraphicalConfig('SDA08', RISK_METRIC_CATEGORIES.StartOfDayAvenues, 'By Type', 'DefaultDonut', 'Two day comparison of Liquidity Buffer Concentration'),
    new DashboardGraphicalConfig('SDA09', RISK_METRIC_CATEGORIES.StartOfDayAvenues, 'By Maturity', 'DefaultDonut', 'Two day comparison of Liquidity Buffer Concentration'),
    new DashboardGraphicalConfig('SDA10', RISK_METRIC_CATEGORIES.StartOfDayAvenues, 'By Level', 'DefaultDonut', 'Two day comparison of Liquidity Buffer Concentration'),
    new DashboardGraphicalConfig('SDA11', RISK_METRIC_CATEGORIES.StartOfDayAvenues, 'By GC/SC', 'DefaultDonut', 'Two day comparison of Liquidity Buffer Concentration'),
    new DashboardGraphicalConfig('SDA12', RISK_METRIC_CATEGORIES.StartOfDayAvenues, 'By Rating', 'DefaultDonut', 'Two day comparison of Liquidity Buffer Concentration'),
    new DashboardGraphicalConfig('SDA13', RISK_METRIC_CATEGORIES.StartOfDayAvenues, 'By Country', 'DefaultDonut', 'Two day comparison of Liquidity Buffer Concentration'),
    new DashboardGraphicalConfig('SDA14', RISK_METRIC_CATEGORIES.StartOfDayAvenues, 'By Sector', 'DefaultDonut', 'Two day comparison of Liquidity Buffer Concentration'),
    new DashboardGraphicalConfig('SH01', RISK_METRIC_CATEGORIES.SurvivalHorizon, 'Survival Horizon', 'DefaultLine', 'Single Day'),
    new DashboardGraphicalConfig('SH02', RISK_METRIC_CATEGORIES.SurvivalHorizon, 'Survival Horizon Compare', 'CompareLine', 'Compare Days'),
    new DashboardGraphicalConfig('SH03', RISK_METRIC_CATEGORIES.SurvivalHorizon, 'Survival Horizon Over Time', 'DefaultLine', 'Historical Trend'),
    new DashboardGraphicalConfig('SH04', RISK_METRIC_CATEGORIES.SurvivalHorizon, 'Liquidity Surplus Over Time', 'DefaultLine', 'Historical Trend'),
    new DashboardGraphicalConfig('SH05', RISK_METRIC_CATEGORIES.SurvivalHorizon, 'Balance Over Time', 'DefaultStackedColumn', 'Historical Trend'),
    new DashboardGraphicalConfig('PA01', RISK_METRIC_CATEGORIES.ProjectionAccuracy, 'Single Day Projections Accuracy', 'DefaultScatterPlot', 'Single Day'),
    new DashboardGraphicalConfig('PA02', RISK_METRIC_CATEGORIES.ProjectionAccuracy, 'Projection Accuracy Comparison', 'DefaultScatterPlot', 'Compare Days'),
    new DashboardGraphicalConfig('PA03', RISK_METRIC_CATEGORIES.ProjectionAccuracy, 'Specific Projection Accuracy Over Time', 'DefaultLine', 'Historical Trend'),
    new DashboardGraphicalConfig('PA04', RISK_METRIC_CATEGORIES.ProjectionAccuracy, 'Relative Projection Accuracy Over Time', 'DefaultScatterPlot', 'Historical Trend'),
    new DashboardGraphicalConfig('NB01', RISK_METRIC_CATEGORIES.NetBreach, 'By Desk', 'DefaultColumn', 'Single Day', ['PAY', 'REC']),
    new DashboardGraphicalConfig('NB02', RISK_METRIC_CATEGORIES.NetBreach, 'By Product Type', 'DefaultColumn', 'Single Day', ['PAY', 'REC']),
    new DashboardGraphicalConfig('NB03', RISK_METRIC_CATEGORIES.NetBreach, 'Two Day Net Breach Comparison by Desk', 'DefaultColumn', 'Compare Days'),
    new DashboardGraphicalConfig('NB04', RISK_METRIC_CATEGORIES.NetBreach, 'Two Day Net Breach Comparison by Product Type', 'DefaultColumn', 'Compare Days'),
    new DashboardGraphicalConfig('NB05', RISK_METRIC_CATEGORIES.NetBreach, 'Multi-day Net Breach Analysis', 'DefaultLine', 'Historical Trend', ['PAY', 'REC']),
    new DashboardGraphicalConfig('FP01', RISK_METRIC_CATEGORIES.FailedPayments, 'Failed Payments by Client Group', 'DefaultStackedColumn', 'Single Day'),
    new DashboardGraphicalConfig('FP02', RISK_METRIC_CATEGORIES.FailedPayments, 'Failed Payments by Product Type', 'DefaultStackedColumn', 'Single Day'),
    new DashboardGraphicalConfig('FP03', RISK_METRIC_CATEGORIES.FailedPayments, 'Failed Payments by Account', 'DefaultStackedColumn', 'Single Day'),
    new DashboardGraphicalConfig('FP04', RISK_METRIC_CATEGORIES.FailedPayments, 'Failed Payments by Client Group', 'DefaultStackedColumn', 'Compare Days'),
    new DashboardGraphicalConfig('FP05', RISK_METRIC_CATEGORIES.FailedPayments, 'Failed Payments by Product Type', 'DefaultStackedColumn', 'Compare Days'),
    new DashboardGraphicalConfig('FP06', RISK_METRIC_CATEGORIES.FailedPayments, 'Failed Payments by Account', 'DefaultStackedColumn', 'Compare Days'),
];

export const RISK_DASHBOARD_REQUESTS: { [key: string]: RiskDashboardRequest } = {
    'IB01': { type: 'INTRADAY_BALANCE', fields: ['roundedDatetime', 'amount'] } as RiskDashboardRequest,
    'IB02': { type: 'INTRADAY_BALANCE', fields: ['roundedDatetime', 'amount'], usageType: RiskMetricDataUsageType.SINGLE_DAY } as RiskDashboardRequest,
    'IB03': { type: 'INTRADAY_BALANCE', fields: ['roundedDatetime', 'amount'] } as RiskDashboardRequest,
    'GP01': { type: 'GROSS_PAYMENTS', fields: ['aggName', 'amount', 'direction'], aggType: 'CLIENT_GROUP' } as RiskDashboardRequest,
    'GP02': { type: 'GROSS_PAYMENTS', fields: ['aggName', 'amount'], direction: 'REC', aggType: 'CLIENT_GROUP' } as RiskDashboardRequest,
    'GP03': { type: 'GROSS_PAYMENTS', fields: ['aggName', 'amount'], direction: 'PAY', aggType: 'CLIENT_GROUP' } as RiskDashboardRequest,
    'GP04': { type: 'GROSS_PAYMENTS', fields: ['aggName', 'amount'], aggType: 'PRODUCT_TYPE' } as RiskDashboardRequest,
    'GP05': { type: 'GROSS_PAYMENTS', fields: ['aggName', 'amount'], aggType: 'PRODUCT_TYPE' } as RiskDashboardRequest,
    'GP06': { type: 'GROSS_PAYMENTS', fields: ['aggName', 'amount'], aggType: 'PRODUCT_TYPE' } as RiskDashboardRequest,
    'GP07': { type: 'GROSS_PAYMENTS_SUM', fields: ['roundedDatetime', 'amount', 'direction'] } as RiskDashboardRequest,
    'GP08': { type: 'GROSS_PAYMENTS_COUNT', fields: ['roundedDatetime', 'amount', 'direction'] } as RiskDashboardRequest,
    'TSP01': { type: 'TIME_SPECIFIC', fields: ['roundedDatetime', 'amount'], direction: 'PAY' } as RiskDashboardRequest,
    'TSP02': { type: 'TIME_SPECIFIC', fields: ['roundedDatetime', 'amount'], direction: 'PAY', aggType: 'CLIENT_GROUP' } as RiskDashboardRequest,
    'TSP03': { type: 'TIME_SPECIFIC_TIMING', fields: ['aggName', 'amount'], direction: 'NET', aggType: 'TRANSACTION' } as RiskDashboardRequest,
    'PTP01': { type: 'PASS_THROUGH', fields: ['account', 'amount'], direction: 'PAY' } as RiskDashboardRequest,
    'PTP02': { type: 'PASS_THROUGH', fields: ['roundedDatetime', 'amount'], direction: 'PAY' } as RiskDashboardRequest,
    'PTP03': { type: 'PASS_THROUGH', fields: ['roundedDatetime', 'amount'], direction: 'PAY' } as RiskDashboardRequest,
    'PTP04': { type: 'PASS_THROUGH_COUNT', fields: ['roundedDatetime', 'amount'], direction: 'PAY' } as RiskDashboardRequest,
    'TP01': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], aggType: 'CLIENT_GROUP' } as RiskDashboardRequest,
    'TP02': { type: 'THROUGHPUT_COUNT', fields: ['roundedDatetime', 'amount', 'direction'], aggType: 'CLIENT_GROUP' } as RiskDashboardRequest,
    'TP03': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], aggType: 'PRODUCT' } as RiskDashboardRequest,
    'TP04': { type: 'THROUGHPUT_COUNT', fields: ['roundedDatetime', 'amount', 'direction'], aggType: 'PRODUCT' } as RiskDashboardRequest,
    'TP05': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], aggType: 'SETTLEMENT_CHANNEL' } as RiskDashboardRequest,
    'TP06': { type: 'THROUGHPUT_COUNT', fields: ['roundedDatetime', 'amount', 'direction'], aggType: 'SETTLEMENT_CHANNEL' } as RiskDashboardRequest,
    'TP07': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], aggType: '' } as RiskDashboardRequest,
    'TP08': { type: 'THROUGHPUT_COUNT', fields: ['roundedDatetime', 'amount', 'direction'], aggType: '' } as RiskDashboardRequest,
    'OTP01': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], direction: 'PAY', aggType: 'CLIENT_GROUP' } as RiskDashboardRequest,
    'OTP02': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], direction: 'PAY', aggType: 'CLIENT_GROUP' } as RiskDashboardRequest,
    'OTP03': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], direction: 'PAY', aggType: 'PRODUCT' } as RiskDashboardRequest,
    'OTP04': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], direction: 'PAY', aggType: 'PRODUCT' } as RiskDashboardRequest,
    'OTP05': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], direction: 'PAY', aggType: 'SETTLEMENT_CHANNEL' } as RiskDashboardRequest,
    'OTP06': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], direction: 'PAY', aggType: 'SETTLEMENT_CHANNEL' } as RiskDashboardRequest,
    'OTP07': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], direction: 'PAY', aggType: '' } as RiskDashboardRequest,
    'OTP08': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], direction: 'PAY', aggType: '' } as RiskDashboardRequest,
    'OTP09': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], direction: 'PAY', aggType: 'CLIENT_GROUP' } as RiskDashboardRequest,
    'OTP10': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], aggType: 'CLIENT_GROUP' } as RiskDashboardRequest,
    'ITP01': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], direction: 'REC', aggType: 'CLIENT_GROUP' } as RiskDashboardRequest,
    'ITP02': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], direction: 'REC', aggType: 'CLIENT_GROUP' } as RiskDashboardRequest,
    'ITP03': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], direction: 'REC', aggType: 'PRODUCT' } as RiskDashboardRequest,
    'ITP04': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], direction: 'REC', aggType: 'PRODUCT' } as RiskDashboardRequest,
    'ITP05': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], direction: 'REC', aggType: 'SETTLEMENT_CHANNEL' } as RiskDashboardRequest,
    'ITP06': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], direction: 'REC', aggType: 'SETTLEMENT_CHANNEL' } as RiskDashboardRequest,
    'ITP07': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], direction: 'REC', aggType: '' } as RiskDashboardRequest,
    'ITP08': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], direction: 'REC', aggType: '' } as RiskDashboardRequest,
    'ITP09': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], direction: 'REC', aggType: 'CLIENT_GROUP' } as RiskDashboardRequest,
    'ITP10': { type: 'THROUGHPUT_SUM', fields: ['roundedDatetime', 'amount', 'direction'], aggType: 'CLIENT_GROUP' } as RiskDashboardRequest,
    'CL01': { type: 'CREDIT_LINE', fields: ['roundedDatetime', 'amount'], usageType: RiskMetricDataUsageType.SINGLE_DAY } as RiskDashboardRequest,
    'NB01': { type: 'NET_BREACH', fields: ['aggName', 'amount', 'direction'], aggType: 'DESK' } as RiskDashboardRequest,
    'NB02': { type: 'NET_BREACH', fields: ['aggName', 'amount', 'direction'], aggType: 'PRODUCT_TYPE' } as RiskDashboardRequest,
    'NB03': { type: 'NET_BREACH', fields: ['aggName', 'roundedDatetime', 'amount', 'direction'], aggType: 'DESK' } as RiskDashboardRequest,
    'NB04': { type: 'NET_BREACH', fields: ['aggName', 'roundedDatetime', 'amount', 'direction'], aggType: 'PRODUCT_TYPE' } as RiskDashboardRequest,
    'NB05': { type: 'NET_BREACH_DAYS', fields: ['roundedDatetime', 'amount'] } as RiskDashboardRequest,
    'SH01': { type: 'HORIZON_BALANCE', fields: ['aggName', 'amount'], usageType: RiskMetricDataUsageType.SINGLE_DAY } as RiskDashboardRequest,
    'SH02': { type: 'HORIZON_BALANCE', fields: ['aggName', 'roundedDatetime', 'amount'], usageType: RiskMetricDataUsageType.SINGLE_DAY } as RiskDashboardRequest,
    'SH03': { type: 'SURVIVAL_HORIZON', fields: ['roundedDatetime', 'amount'] } as RiskDashboardRequest,
    'SH05': { type: 'HORIZON_BALANCE', fields: ['roundedDatetime', 'amount'] } as RiskDashboardRequest,
}

export interface RiskDashboardRequestProcessorContext {
    referenceDate: string;
    filterValues: string[];
    request: RiskDashboardRequest;
    config: DashboardGraphicalConfig;
}

export const RISK_DASHBOARD_REQUEST_PROCESSORS: { [key: string]: (context: RiskDashboardRequestProcessorContext) => RiskDashboardRequest } = {
    'IB02': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate, '2018-05-28'];
        return context.request;
    },
    'OTP01': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
    'OTP02': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
    'OTP03': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
    'OTP04': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
    'OTP05': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
    'OTP06': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
    'OTP07': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
    'OTP08': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
    'ITP01': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
    'ITP02': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
    'ITP03': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
    'ITP04': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
    'ITP05': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
    'ITP06': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
    'ITP07': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
    'ITP08': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
    'NB03': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
    'NB04': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
    'SH02': (context: RiskDashboardRequestProcessorContext): RiskDashboardRequest => {
        context.request.date = [context.filterValues[0], context.referenceDate];
        return context.request;
    },
}

export interface RiskDashboardReponseProcessorContext {
    referenceDate: string;
    rows: any[];
    request: RiskDashboardRequest;
    config: DashboardGraphicalConfig;
}

export const RISK_DASHBOARD_RESPONSE_PROCESSORS: { [key: string]: (context: RiskDashboardReponseProcessorContext) => RiskGraphicalOutput } = {
    'IB01': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'IB02': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => {
        return getCompareAnalysisForGraphical(
            context.rows, context.config, context.referenceDate)
    },
    'IB03': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getStressComparisonAnalysis(context.rows, context.config, context.referenceDate) },
    'GP01': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'GP02': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'GP03': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'GP04': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'GP05': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'GP06': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'GP07': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getHistoricalTrendForGraphical(context.rows, context.config, context.referenceDate) },
    'GP08': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getHistoricalTrendForGraphical(context.rows, context.config, context.referenceDate) },
    'TSP01': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'TSP02': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'TSP03': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'PTP01': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'PTP02': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'PTP03': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getHistoricalTrendForGraphical(context.rows, context.config, context.referenceDate) },
    'PTP04': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getHistoricalTrendForGraphical(context.rows, context.config, context.referenceDate) },
    'TP01': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'TP02': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'TP03': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'TP04': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'TP05': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'TP06': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'TP07': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'TP08': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'OTP01': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'OTP02': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'OTP03': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'OTP04': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'OTP05': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'OTP06': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'OTP07': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'OTP08': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'OTP09': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getHistoricalTrendForGraphical(context.rows, context.config, context.referenceDate) },
    'OTP10': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getStressComparisonAnalysis(context.rows, context.config, context.referenceDate) },
    'ITP01': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'ITP02': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'ITP03': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'ITP04': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'ITP05': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'ITP06': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'ITP07': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'ITP08': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'ITP09': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getHistoricalTrendForGraphical(context.rows, context.config, context.referenceDate) },
    'ITP10': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getStressComparisonAnalysis(context.rows, context.config, context.referenceDate) },
    'NB01': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'NB02': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'NB03': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'NB04': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'NB05': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getHistoricalTrendForGraphical(context.rows, context.config, context.referenceDate) },
    'SH01': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getSingleDayAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'SH02': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getCompareAnalysisForGraphical(context.rows, context.config, context.referenceDate) },
    'SH03': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getHistoricalTrendForGraphical(context.rows, context.config, context.referenceDate) },
    'SH05': (context: RiskDashboardReponseProcessorContext): RiskGraphicalOutput => { return getHistoricalTrendForGraphical(context.rows, context.config, context.referenceDate) },
}

export class RiskGraphicalAdditionalFilter {
    label: string;
    filterField: string;
    required: boolean
}

export const RISK_GRAPHICAL_OPTIONAL_FILTERS: { [key: string]: RiskGraphicalAdditionalFilter[] } = {
    'IB01': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'IB02': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Account', filterField: 'account' } as RiskGraphicalAdditionalFilter,
    ],
    'IB03': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'GP01': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Account', filterField: 'account' } as RiskGraphicalAdditionalFilter
    ],
    'GP02': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Account', filterField: 'account' } as RiskGraphicalAdditionalFilter
    ],
    'GP03': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Account', filterField: 'account' } as RiskGraphicalAdditionalFilter
    ],
    'GP04': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Account', filterField: 'account' } as RiskGraphicalAdditionalFilter
    ],
    'GP05': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Account', filterField: 'account' } as RiskGraphicalAdditionalFilter
    ],
    'GP06': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Account', filterField: 'account' } as RiskGraphicalAdditionalFilter
    ],
    'GP07': [
        { label: 'Trend', filterField: 'usageType', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Account', filterField: 'account' } as RiskGraphicalAdditionalFilter
    ],
    'GP08': [
        { label: 'Trend', filterField: 'usageType', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Account', filterField: 'account' } as RiskGraphicalAdditionalFilter
    ],
    'TSP01': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Client Group', filterField: 'aggName' } as RiskGraphicalAdditionalFilter,
    ],
    'TSP02': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Client Group', filterField: 'aggName' } as RiskGraphicalAdditionalFilter,
    ],
    'TSP03': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Client Group', filterField: 'aggName' } as RiskGraphicalAdditionalFilter,
    ],
    'PTP01': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Client Group', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'PTP02': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Client Group', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'PTP03': [
        { label: 'Trend', filterField: 'usageType', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Client Group', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'PTP04': [
        { label: 'Trend', filterField: 'usageType', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Client Group', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'CL01': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Client', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'CL02': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Client', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'CL03': [
        { label: 'Trend', filterField: 'usageType', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Client', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'TP01': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'TP02': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'TP03': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'TP04': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'TP05': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'TP06': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'TP07': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'account' } as RiskGraphicalAdditionalFilter
    ],
    'TP08': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'account' } as RiskGraphicalAdditionalFilter
    ],
    'OTP01': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Direction', filterField: 'direction', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName', required: true } as RiskGraphicalAdditionalFilter
    ],
    'OTP02': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'OTP03': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'OTP04': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'OTP05': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'OTP06': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'OTP07': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'account' } as RiskGraphicalAdditionalFilter
    ],
    'OTP08': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'account' } as RiskGraphicalAdditionalFilter
    ],
    'OTP09': [
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'OTP10': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'ITP01': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'ITP02': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'ITP03': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'ITP04': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'ITP05': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'ITP06': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'ITP07': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'account' } as RiskGraphicalAdditionalFilter
    ],
    'ITP08': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'account' } as RiskGraphicalAdditionalFilter
    ],
    'ITP10': [
        { label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'ITP09': [
        { label: 'Category', filterField: 'aggName' } as RiskGraphicalAdditionalFilter
    ],
    'SDA01': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'SDA02': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'SDA03': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'SDA04': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'SDA05': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'SDA06': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'SDA07': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'SDA08': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'SDA09': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'SDA10': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'SDA11': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'SDA12': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'SDA13': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'SDA14': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'SH01': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'SH02': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'SH03': [{ label: 'Trend', filterField: 'usageType', required: true } as RiskGraphicalAdditionalFilter],
    'SH04': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'SH05': [
        { label: 'Trend', filterField: 'usageType', required: true } as RiskGraphicalAdditionalFilter,
        { label: 'Tenor', filterField: 'aggName', required: true } as RiskGraphicalAdditionalFilter
    ],
    'PA01': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'PA02': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'PA03': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'PA04': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'NB01': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'NB02': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'NB03': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'NB04': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'NB05': [{ label: 'Trend', filterField: 'usageType', required: true } as RiskGraphicalAdditionalFilter],
    'FP01': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'FP02': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'FP03': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'FP04': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'FP05': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
    'FP06': [{ label: 'Date', filterField: 'date', required: true } as RiskGraphicalAdditionalFilter],
}

export const RISK_GRAPHICAL_YFIELDS: { [key: string]: { field: string, label: string }[] } = {
    'GP07': [{ field: 'PAY', label: 'Payments' }, { field: 'REC', label: 'Receipts' }, { field: 'total', label: 'Total' }],
    'GP08': [{ field: 'PAY', label: 'Payments' }, { field: 'REC', label: 'Receipts' }, { field: 'total', label: 'Total' }],
    'NB01': [{ field: 'PAY', label: 'Payments' }, { field: 'REC', label: 'Receipts' }],
    'NB02': [{ field: 'PAY', label: 'Payments' }, { field: 'REC', label: 'Receipts' }],
    'NB03': [{ field: 'PAY0', label: 'Payments' }, { field: 'REC0', label: 'Receipts' }, { field: 'PAY1', label: 'Payments' }, { field: 'REC1', label: 'Receipts' }],
    'NB04': [{ field: 'PAY0', label: 'Payments' }, { field: 'REC0', label: 'Receipts' }, { field: 'PAY1', label: 'Payments' }, { field: 'REC1', label: 'Receipts' }],
}

export const RISK_METRIC_SETS = [
    {
        type: 'Top3',
        label: 'Top Actual Positive Balance',
        metrics: ['TOP_ACTUAL_POSITIVE_BALANCE_1', 'TOP_ACTUAL_POSITIVE_BALANCE_2', 'TOP_ACTUAL_POSITIVE_BALANCE_3']
    } as DashboardMetricSet,
    {
        type: 'Top3',
        label: 'Top Actual Negative Balance',
        metrics: ['TOP_ACTUAL_NEGATIVE_BALANCE_1', 'TOP_ACTUAL_NEGATIVE_BALANCE_2', 'TOP_ACTUAL_NEGATIVE_BALANCE_3']
    } as DashboardMetricSet,
    {
        type: 'Top3',
        label: 'Top Theoretical Positive Balance',
        metrics: ['TOP_THEORETICAL_POSITIVE_BALANCE_1', 'TOP_THEORETICAL_POSITIVE_BALANCE_2', 'TOP_THEORETICAL_POSITIVE_BALANCE_3']
    } as DashboardMetricSet,
    {
        type: 'Top3',
        label: 'Top Theoretical Negative Balance',
        metrics: ['TOP_THEORETICAL_NEGATIVE_BALANCE_1', 'TOP_THEORETICAL_NEGATIVE_BALANCE_2', 'TOP_THEORETICAL_NEGATIVE_BALANCE_3']
    } as DashboardMetricSet,
    {
        type: 'Top3',
        label: 'Largest Incoming',
        metrics: ['LARGEST_INCOMING_1', 'LARGEST_INCOMING_2', 'LARGEST_INCOMING_3']
    } as DashboardMetricSet,
    {
        type: 'Top3',
        label: 'Largest Outgoing',
        metrics: ['LARGEST_OUTGOING_1', 'LARGEST_OUTGOING_2', 'LARGEST_OUTGOING_3']
    } as DashboardMetricSet,
    {
        type: 'Top3',
        label: 'Largest Time Specific',
        metrics: ['LARGEST_TIME_SPECIFIC_1', 'LARGEST_TIME_SPECIFIC_2', 'LARGEST_TIME_SPECIFIC_3']
    } as DashboardMetricSet,
    {
        type: 'Top3',
        label: 'Count Time Specific',
        metrics: ['COUNT_TIME_SPECIFIC_1', 'COUNT_TIME_SPECIFIC_2', 'COUNT_TIME_SPECIFIC_3']
    } as DashboardMetricSet,
    {
        type: 'Top3',
        label: 'Largest Pass Through',
        metrics: ['LARGEST_PASS_THROUGH_1', 'LARGEST_PASS_THROUGH_2', 'LARGEST_PASS_THROUGH_3']
    } as DashboardMetricSet,
    {
        type: 'Top3',
        label: 'Highest Line Usage',
        metrics: ['HIGHEST_LINE_USAGE_1', 'HIGHEST_LINE_USAGE_2', 'HIGHEST_LINE_USAGE_3']
    } as DashboardMetricSet,
    {
        type: 'Top3',
        label: 'Liquidity Buffer',
        metrics: ['LIQUIDITY_BUFFER_1', 'LIQUIDITY_BUFFER_2', 'LIQUIDITY_BUFFER_3']
    } as DashboardMetricSet,
    {
        type: 'Top3',
        label: 'Survival Horizon',
        metrics: ['SURVIVAL_HORIZON_1', 'SURVIVAL_HORIZON_2', 'SURVIVAL_HORIZON_3']
    } as DashboardMetricSet,
    {
        type: 'Top3',
        label: 'Failed Payment Sum',
        metrics: ['FAILED_PAYMENT_SUM_1', 'FAILED_PAYMENT_SUM_2', 'FAILED_PAYMENT_SUM_3']
    } as DashboardMetricSet,
    {
        type: 'Top3',
        label: 'Failed Payment Count',
        metrics: ['FAILED_PAYMENT_COUNT_1', 'FAILED_PAYMENT_COUNT_2', 'FAILED_PAYMENT_COUNT_3']
    } as DashboardMetricSet,
];


export function convertToDashboardMetricSets(metrics: string[]): DashboardMetricSet[] {
    const metricSetBySetLabel = metrics.reduce((grouped, metric) => {

        let metricSet = getRegisteredMetricSet(metric);
        if (metricSet) {
            grouped[metricSet.label] = metricSet;
        } else {
            metricSet = grouped[metric];
            if (!metricSet) {
                metricSet = createDashboardMetricSet(metric);
                grouped[metric] = metricSet;
            } else {
                metricSet.metrics.push(metric);
            }
        }
        return grouped;
    }, {});
    const sets: DashboardMetricSet[] = Object.keys(metricSetBySetLabel)
        .map((label: string) => {
            return metricSetBySetLabel[label];
        });
    return sets;
}

function getRegisteredMetricSet(metric: string): DashboardMetricSet {
    const foundSet = RISK_METRIC_SETS.find((set: DashboardMetricSet) => {
        return set.metrics.includes(metric);
    })
    if (foundSet) {
        return Object.assign({}, foundSet);
    }
}

function createDashboardMetricSet(metric: string): DashboardMetricSet {
    return {
        type: 'Single',
        label: convertFromRiskMetricNameToLabel(metric),
        metrics: [metric]
    } as DashboardMetricSet;

}

const METRIC_LABELS = {
    LCR: 'LCR',
}
function convertFromRiskMetricNameToLabel(metric: string): string {
    let label = METRIC_LABELS[metric];
    if (!label) {
        label = convertFromConstantToHuman(metric);
    }
    return label;
}
